import { CoreService } from "./../../base/core";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ServiceRoute } from "../../base/service-route";
import { CommonHttpOption } from "../../base/common-http-option";
import { ICalendar } from "src/app/interfaces/calendar";

@Injectable({
  providedIn: "root"
})
export class CalendarService {
  constructor(private coreService: CoreService) {}

  calendarHolidayList(): Observable<any> {
    return this.coreService.get(
      ServiceRoute.calendar.calendarHolidayList,
      new CommonHttpOption().headers
    );
  }


  list(params:any): Observable<any> {
    return this.coreService.get(
      ServiceRoute.calendar.list + params.persianYear + params.persianMonth + params.calendarHolidayId,
      new CommonHttpOption().headers
    );
  }

  getCalendarHolidayList(filter:any): Observable<any> {
    let queryParams=`?xStartDate=${filter.startDate}
    &xEndDate=${filter.endDate}
    &xCalendarHolidayId=${filter.calendarHolidayId}`;
    return this.coreService.get(
      ServiceRoute.calendar.getCalendarHolidayList + queryParams,
      new CommonHttpOption().headers
    );
  }

  calendarHolidayListByCurentDate(filter:any): Observable<any> {

    let queryParams=`?xDataPersian=${filter.date}&xCalendarHolidayId=${filter.calendarHolidayId}`;
    return this.coreService.get(
      ServiceRoute.calendar.calendarHolidayListByCurentDate + queryParams,
      new CommonHttpOption().headers
    );
  }

  calendarByDate(): Observable<any> {
    return this.coreService.get(
      ServiceRoute.calendar.calendarByDate,
      new CommonHttpOption().headers
    );
  }

  yearList(): Observable<any> {
    return this.coreService.get(
      ServiceRoute.calendar.GetYearsList,
      new CommonHttpOption().headers,
      new CommonHttpOption().params
    );
  }

  save(data:any): Observable<any> {
    return this.coreService.post(
      ServiceRoute.calendar.save,
      data,
      new CommonHttpOption().headers
    );
  }

  edit(data: ICalendar): Observable<any> {
    return this.coreService.put(
      ServiceRoute.calendar.edit,
      data,
      new CommonHttpOption().headers
    );
  }

  holidayTypeEdit(data: any): Observable<any> {
    return this.coreService.put(
      ServiceRoute.calendar.holidayTypeEdit,
      data,
      new CommonHttpOption().headers
    );
  }

  holidayTypeAdd(data:any): Observable<any> {
    return this.coreService.post(
      ServiceRoute.calendar.holidayTypeAdd,
      data,
      new CommonHttpOption().headers
    );
  }


  holidayTypeList(): Observable<any> {
    return this.coreService.get(
      ServiceRoute.calendar.holidayTypeList,
      new CommonHttpOption().headers
    );
  }

  hasDateList(TermInfoId:number): Observable<any> {
    return this.coreService.get(
      ServiceRoute.calendar.hasDateList+TermInfoId,
      new CommonHttpOption().headers
    );
  }
}
